import { createReducer, on } from '@ngrx/store';

import { OperatorSettingsActions } from '../actions/operator-settings.actions';
import { INITIAL_SETTINGS_STATE } from '../operator-settings.state';

export const operatorSettingsReducer = createReducer(
  INITIAL_SETTINGS_STATE,

  on(OperatorSettingsActions.load, (state) => ({
    ...state,
    loadState: 'loading' as const,
    error: null,
  })),

  on(OperatorSettingsActions.loadSuccess, (state, { settings }) => ({
    ...state,
    settings,
    loadState: 'loaded' as const,
    error: null,
  })),

  on(OperatorSettingsActions.loadFailure, (state, { error }) => ({
    ...state,
    loadState: 'error' as const,
    error,
  })),

  on(OperatorSettingsActions.updateSuccess, (state, { settings }) => ({
    ...state,
    settings,
  })),

  on(OperatorSettingsActions.updateFailure, (state, { error }) => ({
    ...state,
    error,
  })),

  on(OperatorSettingsActions.uploadPSIDsFailure, (state, { error }) => ({
    ...state,
    error,
  })),

  on(
    OperatorSettingsActions.uploadUnicornQuotasFailure,
    (state, { error }) => ({
      ...state,
      error,
    }),
  ),

  on(
    OperatorSettingsActions.downloadUnicornMappingsFailure,
    (state, { error }) => ({
      ...state,
      error,
    }),
  ),

  on(OperatorSettingsActions.uploadCrmIdFailure, (state, { error }) => ({
    ...state,
    error,
  })),
);
